// extracted by mini-css-extract-plugin
module.exports = {"dots":"testimonial-manager-module--dots--3CPN3","inactive":"testimonial-manager-module--inactive--3lU5a"};